export default function (ctx) {
    // const token = ctx.query.authToken;
    // ctx.app.$cookiz.set("access_token", token, /* { httpOnly: true } */);
    // ctx.$axios
    //     .$get("/api/v1/camdigikey/request-login/")
    //     .then((res) => {})
    //     .catch((e) => {});
}
